module.exports = __webpack_public_path__ + "img/sample-driver-license-card.ce5e6407.png";